export default __webpack_public_path__ + "static/media/ajanvaraus-lightblue.ad2262f8.svg";